import React from 'react';
import { sideProjects } from '../data/siteData';
import ProjectCard from '../components/ProjectCard';
import ListPage from '../components/ListPage';

const SideProjects = () => (
  <ListPage
    title="Side Projects"
    intro="Things I've built for fun, learning, or to scratch an itch."
    items={sideProjects}
    renderItem={(project, index) => <ProjectCard key={index} project={project} full />}
    cta={{ label: 'Curious about my professional work?', title: 'View Work', to: '/work' }}
  />
);

export default SideProjects;